import { configureStore } from '@reduxjs/toolkit'
import thunkMiddleware from 'redux-thunk'
import app from 'store/appSlice'
import map from 'store/mapSlice'

import { config } from 'api/reducers'
import { configManagerOpen } from 'ConfigManager/reducers'
import { fragments } from 'drawer/tabs/info/fragment/reducers'
import { annotationInfo } from 'drawer/tabs/layers/annotations/reducers'
import { groups, layers, profiles, currentProfile } from 'drawer/tabs/layers/reducers'
import { tabLayersFilter } from 'drawer/tabs/layers/search/reducers'
import { table } from 'drawer/tabs/layers/table/reducers'
import { bMapLoaded, currentTarget, currentTargetChildren, currentTargetIntersectLayers, currentTargetWhatsHere, mapContextMenu, mapX, mapY, mapZ } from 'map/reducers'
import {
  printBlobURL,
  printFitMap,
  printIncludesMap,
  printMapCurrentScale,
  printMapDpi,
  printOrientation,
  printReport,
  printScale,
  printSidePanel,
  printSize,
  printStats,
  printTitle,
  printUIVisible
} from 'utils/Print/reducers'
import { snackbarOptions } from 'utils/snackbar/reducers'

// import AppWrapper from 'app/AppWrapper'

const preloadedState = {
  config: {},
  /* olMap: null, */
  bMapLoaded: false,
  mapContextMenu: null,
  mapX: 0,
  mapY: 0,
  mapZ: 0,
  layers: {},
  profiles: {},
  groups: {},
  tabLayersFilter: '',
  currentProfile: null,
  currentTarget: null,
  currentTargetWhatsHere: null,
  currentTargetChildren: null,
  currentTargetIntersectLayers: null,
  fragments: [], // Fragments are data extracted from selection of current target
  snackbarOptions: {
    message: '',
    open: false,
    vertical: null,
    horizontal: null,
    autoHideDuration: null
  },
  printUIVisible: false,
  configManagerOpen: false,
  printScale: 0,
  // printScale: 107530,
  printSize: 'A4',
  printOrientation: 'landscape',
  // printOrientation: 'portrait',
  printTitle: '',
  printBlobURL: '',
  printMapCurrentScale: null,
  printMapDpi: 100,
  printReport: { layer: '', groupAttribute: '' },
  printSidePanel: '',
  printIncludesMap: true,
  printFitMap: false,
  printStats: false,
  annotationInfo: { titleid: '', type: '', label: '' },
  table: { data: null, open: false, status: '', titleid: '' }
}

const reducer = {
  layers,
  profiles,
  groups,
  currentProfile,
  currentTarget,
  currentTargetWhatsHere,
  currentTargetChildren,
  currentTargetIntersectLayers,
  config,
  bMapLoaded,
  mapContextMenu,
  mapX,
  mapY,
  mapZ,
  fragments,
  snackbarOptions,
  printTitle,
  printUIVisible,
  configManagerOpen,
  printScale,
  printSize,
  printOrientation,
  printBlobURL,
  printMapCurrentScale,
  printMapDpi,
  printSidePanel,
  printIncludesMap,
  printFitMap,
  printReport,
  printStats,
  annotationInfo,
  table,
  tabLayersFilter,
  app,
  map
}

export type RootState = ReturnType<typeof reduxStore.getState>

// We may add more middleware below
const middleware = [thunkMiddleware]

// Enable redux logger if enabled via env var REACT_APP_LOG
// const REDUX_LOGGER = process.env.REACT_APP_REDUX_LOGGER && (process.env.REACT_APP_REDUX_LOGGER.toLowerCase() !== 'false')
// if (REDUX_LOGGER) {
//   const reduxLogger = createLogger({
//     collapsed: true
//   })

// Create Redux store
// See: https://redux-toolkit.js.org/
export const reduxStore = configureStore({
  reducer: reducer as any, // TODO: fix this
  preloadedState: preloadedState as any, // TODO: fix this
  middleware
}) // as NonNullable<ReturnType<typeof configureStore>>
